import Platforms from "../Platforms";
import './style.scss';
import { useEffect, useState } from "react";

const Contact = () => {
    const [emailAddress, setEmailAddress] = useState('');
    const [messageContent, setMessageContent] = useState('');

    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);

    const [successMessage, setSuccessMessage] = useState('');
    const [emailValidationError, setEmailValidationError] = useState(false);
    const [emailRequiredError, setEmailRequiredError] = useState(true);
    const [messageRequiredError, setMessageRequiredError] = useState(true);


    useEffect(() => {
        setEmailValidationError(false);
        setEmailRequiredError(emailAddress.trim().length === 0);
        setMessageRequiredError(messageContent.trim().length === 0);
    }, [emailAddress, messageContent]);

    useEffect(() => {
        setHasErrors(emailRequiredError || messageRequiredError || emailValidationError);
    }, [emailRequiredError, messageRequiredError, emailValidationError]);

    const resetState = () => {
        setSubmitted(false);
        setEmailAddress("");
        setMessageContent("");
    }

    const contactUs = () => {
        setSubmitted(true);

        if (hasErrors) {
            return;
        }

        setSubmitting(true);
        const myHeaders = new Headers();
        const body = JSON.stringify({
            emailAddress,
            message: messageContent
        });

        myHeaders.append("Content-Type", "application/json");
        fetch("/api/contact-us", {
            method: "POST",
            headers: myHeaders,
            body,
            redirect: "follow"
        })
          .then((response) => {
              setSubmitting(false);

              if (response.status === 200) {
                  setSuccessMessage("Thank you for contacting us. Well respond soon.")
                  resetState();
              } else if (response.status === 400) {
                  response.text().then(bodyString => {
                      const body = JSON.parse(bodyString);
                      if (body.message.includes("Invalid email address")) {
                          setEmailValidationError(true);
                      }
                  });
              }
          })
          .catch((error) => {
              setSubmitting(false);
              console.warn(error);
          });
    };

    return (
        <div className="container">
            <div className="row align-items-center gy-5">
                <div className="col-xl-5 col-lg-5 col-md-5 col-12">
                    {successMessage && (
                      <div className="mt-4 p-2">
                          Your message has been sent successfully!
                      </div>
                    )}
                    {!successMessage && 
                        <div>
                            <div className="mb-5 contact-us-message">
                                Contact us at <a href="mailto:contact@drixylabs.com" className="text-decoration-none contact-link">contact@drixylabs.com</a> or send us a message using the form below.
                            </div>
                            <form>
                                <div className="form-group mb-4">
                                    <label htmlFor="email" className="mb-2">Email address</label>
                                    <input value={emailAddress}
                                        onChange={e => setEmailAddress(e.target.value)}
                                        type="email" className="form-control" id="email"/>
                                    {emailRequiredError && submitted && <span style={{color: 'red'}}>Email is required</span>}
                                    {emailValidationError && submitted && <span style={{color: 'red'}}>Email is invalid</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message" className="mb-2">Type a message</label>
                                    <textarea value={messageContent} onChange={e => setMessageContent(e.target.value)}
                                            className="form-control" id="message" rows="3"></textarea>
                                    {messageRequiredError && submitted && <span style={{color: 'red'}}>Message is required</span>}
                                </div>
                                <button type="button" disabled={submitting || (submitted && hasErrors)} onClick={contactUs} className="btn filled-btn mt-4">Submit</button>
                            </form>
                        </div>
                    }
                </div>
                <div className="col-xl-7 col-lg-7 col-md-7 col-12 text-end">
                    <div className="main-image">
                        <img src="./main.png" className="img-fluid" alt="Main" />
                    </div>
                </div>
            </div>
            <div className="row align-items-center px-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                    <Platforms />
                </div>
            </div>
        </div>
    );
};

export default Contact;
